import React, { useState, useRef } from "react";
import SectionHeading from "./sectionHeading";
import ContainerCard from "./containerCard";
import SubmissionConfirmation from "./submissionConfirmation";
import { Button, Input } from "@speedoc/design-assets";
import { useMediaQuery } from "react-responsive";
import sendEmail from "../../utils/sendEmail";
import { trackCustom } from "../../services/analytics";
import { GlobalStore } from "../../stores/global";
import { Remarkable } from "remarkable";
const markdown = new Remarkable();

export default function ContactFormEmail({ content }) {
  const {
    currentCountryCode: countryCode,
    currentCountry: { phoneNumberText, phoneNumberLink }
  } = GlobalStore.useState(c => c);
  const initialState = {
    email: "",
    name: "",
    phone: ""
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formHeight, setFormHeight] = useState(undefined);
  const [formData, setFormData] = useState(initialState);
  const targetRef = useRef();

  const { title, subtitle, emailFrom, emailTo, parent, fields, subject, source } = content;
  const formInfo = { fields, emailFrom, parent, subject, emailTo, source };
  const [error, setError] = useState(false);

  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  const isChromeOrFirefox = () => {
    const operaAgent = navigator.userAgent.indexOf(" OPR/") > -1;
    const safariAgent =
      navigator.vendor.indexOf("Apple") > -1 &&
      navigator.userAgent.indexOf("CriOS") === -1 &&
      navigator.userAgent.indexOf("FxiOS") === -1;
    return operaAgent === false && safariAgent === false;
  };

  const handleInputChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (formData.email.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)) {
      try {
        await sendEmail(formData, formInfo);
        setFormHeight(targetRef.current.offsetHeight);
      } catch (err) {
        console.log(err);
      } finally {
        trackCustom("Lead", countryCode, { email: formData.email });
        setError(false);
        setIsSubmitting(false);
        setIsSubmitted(true);
        setFormData({ ...initialState });
      }
    } else {
      setError("Please enter a valid email.");
      setIsSubmitting(false);
    }
  };

  const handleBackClick = () => {
    setIsSubmitted(false);
  };

  return (
    <div className="contactFormEmail">
      {title && <SectionHeading title={title} subtitle={subtitle} />}
      <ContainerCard>
        {!isSubmitted ? (
          <div className="container" ref={targetRef}>
            <div className="textSection">
              <div className="title">{content.text?.title || content.formTitle}</div>
              {content.description ? (
                <div
                  className="description"
                  dangerouslySetInnerHTML={{ __html: markdown.render(content.description) }}
                />
              ) : (
                <div className="description">
                  Send us an enquiry or call us at <br />
                  <a href={phoneNumberLink}>
                    <strong>{phoneNumberText}</strong>
                  </a>
                  . <br /> We will get back to you within the next two (2) working days.
                </div>
              )}
            </div>
            <form className="formSection">
              <Input
                className={`sm ${isChromeOrFirefox() ? "" : "margin-bottom"}`}
                required
                id="name"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleInputChange}
              />
              <Input
                className="sm"
                required
                id="phone"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleInputChange}
              />
              <div className="email">
                <Input
                  className={`sm ${isChromeOrFirefox() ? "" : "margin-bottom"} ${
                    error && error.includes("email") ? "error" : ""
                  }`}
                  required
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>
              <div>
                {!isMobile && (
                  <Button onClick={handleSubmit} disabled={isSubmitting} className="primary sm">
                    {isSubmitting ? "Please wait..." : content.buttonText}
                  </Button>
                )}
                {!isMobile && error ? <p className="errorMessage">{error}</p> : null}
              </div>
            </form>
            {isMobile && (
              <div className="buttonSection">
                <Button onClick={handleSubmit} disabled={isSubmitting} className="primary sm">
                  {isSubmitting ? "Please wait..." : content.buttonText}
                </Button>
                {error ? <p className="errorMessage">{error}</p> : null}
              </div>
            )}
          </div>
        ) : (
          <SubmissionConfirmation formHeight={formHeight} handleBackClick={handleBackClick} />
        )}
      </ContainerCard>
    </div>
  );
}
